/**
 * Utility functions for Dashboard KPI aggregations.
 * These functions are pure and only read existing data arrays.
 */

export const getOpenTasksCount = (tasks: any[]) => {
    if (!tasks) return 0;
    return tasks.filter(t => t.status !== 'done' && !t.completed).length;
};

export const getOverdueTasksCount = (tasks: any[]) => {
    if (!tasks) return 0;
    const today = new Date().toISOString().split('T')[0];
    return tasks.filter(t => t.status !== 'done' && !t.completed && t.dueDate && t.dueDate < today).length;
};

export const getRenewalsCount = (customers: any[], days: number = 30) => {
    if (!customers) return 0;
    const today = new Date();
    const futureDate = new Date();
    futureDate.setDate(today.getDate() + days);

    let count = 0;
    customers.forEach(c => {
        const contracts = c.verträge || c.vertraege || [];
        contracts.forEach((v: any) => {
            const expiry = parseDate(v.ablauf);
            if (expiry && expiry >= today && expiry <= futureDate) {
                count++;
            }
        });
    });
    return count;
};

export const getTodayShiftsCount = (shifts: any[]) => {
    if (!shifts) return 0;
    const todayStr = new Date().toISOString().split('T')[0];
    return shifts.filter(s => s.date === todayStr).length;
};

export const getGoalProgressPercentage = (goal: any) => {
    if (!goal || !goal.target || goal.target === 0) return 0;
    return Math.round((goal.current / goal.target) * 100);
};

// Helper for date parsing
const parseDate = (s: any) => {
    if (!s) return null;
    if (typeof s === 'string' && s.includes('-')) {
        const [y, m, d] = s.split('-');
        return new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
    }
    if (typeof s === 'string' && s.includes('.')) {
        const [d, m, y] = s.split('.');
        return new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
    }
    return null;
};
